export var main_header_style = {
  'background': 'black',
  'width': '100%',
  'height': '50px',
  'title-font-size': '30px',
  'title-margin': {'left': '10px', 'right': '5px'},
  'title-color': 'white',
  'subtitle-font-size': '20px',
  'subtitle-margin': {'left': '0px', 'right': '5px'},
  'subtitle-color': 'lightgray'
}

export var layout_style = {
  'screen-width': 1200
}

export var header_style = {
  'normal-font-size': 13,
  'between': 3,
  'start': 10,
  'end': 10
}

export var bg_img_style = {
  'overlap': {
    'width': 400,
    'height': 300,
    'stroke-width': 3
  },
  'separate': {
    'width': 200,
    'height': 150,
    'stroke-width': 3
  },
  'frame': {
    'width': 88,
    'height': 66,
    'stroke-width': 3
  },
  'original': {
    'width': 320,
    'height': 240
  }
}

export var control_style = {
  'benign': {
    'y': 0
  },
  'attacked': {
    'y': 6
  }
}

export var frame_style = {
  'benign': {
    'y': 3,
    'stroke-width': 5
  },
  'attacked': {
    'y': 3,
    'stroke-width': 5
  },
  'default': {
    'stroke-width': 1
  }
}

export var color_dict = {
  'benign': '#33BB33',
  'attacked': '#FF8800',
  'normal': '#FFFFFF',
  'bg-img-border': '#000000'
}

export var data_dir = 'item-00018'

// export var data_path = {
//   'data_dir': 'data',
//   'benign_frame_dir': `${data_dir}/clip-lunges-benign`, 
//   'attacked_frame_dir': `${data_dir}/clip-lunges-adversarial`,
//   'benign_confidence_dir': `${data_dir}/confidence-lunges-benign`,
//   'attacked_confidence_dir': `${data_dir}/confidence-lunges-adversarial`,
//   'attacked_perturbation_dir': `${data_dir}/clip-lunges-perturbation`,  
//   'benign_skeleton_filepath': `${data_dir}/benign-skeleton.csv`,
//   'attacked_skeleton_filepath': `${data_dir}/adv-skeleton.csv`,
// }

export var data_path = {
  'data_dir': 'skeletonvis_data/',
  'benign_frame_dir': `skeletonvis_data/${data_dir}/clips-benign`, 
  'attacked_frame_dir': `skeletonvis_data/${data_dir}/clips-attacked-eps_001`,
  'benign_confidence_dir': `skeletonvis_data/${data_dir}/confidence-lunges-benign`,
  'attacked_confidence_dir': `skeletonvis_data/${data_dir}/confidence-lunges-adversarial`,
  'attacked_perturbation_dir': `skeletonvis_data/${data_dir}/clip-lunges-perturbation`,  
  'benign_skeleton_filepath': `skeletonvis_data/${data_dir}/keypoints-benign.csv`,
  'attacked_skeleton_filepath': `skeletonvis_data/${data_dir}/keypoints-attacked-eps_001.csv`,
  'benign_displacement_filepath': `skeletonvis_data/${data_dir}/displacements-benign.csv`,
  'attacked_displacement_filepath': `skeletonvis_data/${data_dir}/displacements-attacked-eps_001.csv`
}

export var icon_class = {
  'background': 'fas fa-vector-square',
  'dropdown-down': 'fas fa-caret-down',
  'dropdown-up': 'fas fa-caret-up',
  'skeleton': 'fas fa-bone',
  'check': 'fas fa-check-square',
  'uncheck': 'far fa-square',
  'on': 'fas fa-toggle-on',
  'off': 'fas fa-toggle-off',
  'play': 'fas fa-play',
  'pause': 'fas fa-pause',
  'step-forward': 'fas fa-step-forward',
  'step-backward': 'fas fa-step-backward',
  'fast-forward': 'fas fa-fast-forward',
  'fast-backward': 'fas fa-fast-backward'
}

export var control_board_style = {
  'text-font-size': 13,
  'text-left-padding': 3,
  'text-transform': 'translate(0px, -2px)',
  'keypoints-selection-div-height': 120
}

export var keypoints = [
  'nose', 'left_eye', 'right_eye', 'left_ear', 'right_ear',
  'left_shoulder', 'right_shoulder', 'left_elbow', 'right_elbow',
  'left_wrist', 'right_wrist', 'left_hip', 'right_hip',
  'left_knee', 'right_knee', 'left_ankle', 'right_ankle'
]

export var skeletons = [
  [16, 14], [14, 12], [17, 15], [15, 13], [12, 13], [6, 12], [7, 13], [6, 7],
  [6, 8], [7, 9], [8, 10], [9, 11], [2, 3], [1, 2], [1, 3], [2, 4], [3, 5],
  [4, 6], [5, 7]
];

export var time_style = {
  'slider-bar-color': '#777777',
  'slider-bar-height': 10,
  'slider-bar-border-radius': 0,
  'slider-knob-border-radius': 3,
  'knob-width': 10,
  'knob-height': 40,
  'knob-font-size': 13,
  'knob-text-x': -23,
  'knob-text-y': -35,
  'button-margin-top': 100,
  'button-size': 25
}

